export default __webpack_public_path__ + "static/media/logo-icon2.3c09d438.png";